// // LoadingStyles.js

// import styled, { keyframes } from 'styled-components';

// // Keyframe for the loading animation
// const rotate360 = keyframes`
//   to {
//     transform: rotate(360deg);
//   }
// `;

// // Loading container styling
// export const LoadingContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   height: 100vh;
//   background-color: #000; /* Black background */
//   color: #fff; /* White text color */
//   font-weight: bold;
//   font-size: 24px;
// `;

// // Loading spinner styling
// export const LoadingSpinner = styled.div`
//   width: 50px;
//   height: 50px;
//   border: 5px solid #fff; /* White border */
//   border-radius: 50%;
//   border-top: 5px solid transparent; /* Transparent top border */
//   animation: ${rotate360} 1s linear infinite; /* Apply the rotating animation */
// `;

// // Loading text styling
// export const LoadingText = styled.p`
//   margin-left: 10px;
// `;


import styled, { keyframes } from 'styled-components';

// Keyframe for the loading animation
const rotate360 = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const animateLetters = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #000; /* Black background */
  color: #fff; /* White text color */
  font-weight: bold;
  font-size: 24px;
`;

// Loading spinner styling
export const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #fff; /* White border */
  border-radius: 50%;
  border-top: 5px solid transparent; /* Transparent top border */
  animation: ${rotate360} 1s linear infinite; /* Apply the rotating animation */
`;

export const LoadingText = styled.p`
  margin-left: 10px;
  display: inline-block;
  opacity: 0;
  animation: ${fadeIn} 0.5s forwards;
  animation-delay: 0.2s;

  &:nth-child(1) {
    animation-delay: 0.2s;
  }

  &:nth-child(2) {
    animation-delay: 0.4s;
  }

  &:nth-child(3) {
    animation-delay: 0.6s;
  }

  &:nth-child(4) {
    animation-delay: 0.8s;
  }

  &:nth-child(5) {
    animation-delay: 1s;
  }

  &:nth-child(6) {
    animation-delay: 1.2s;
  }

  &:nth-child(7) {
    animation-delay: 1.4s;
  }
`;